import type { QueryParams } from '@meishi/shared/src/types/page'
import Axios from 'axios'
import router from '@/router'
import store from '@/store'
import { UPDATE_ME } from '@/store/types'
import { STORAGE_PERSON_ID } from '@/utils/constants'

export async function uc() {
  return Axios.get('/portal/uc/profile', { ignoreError: true }).then((res) => {
    store.commit(UPDATE_ME, res.data)
    localStorage.setItem(STORAGE_PERSON_ID, res.data.id)
    return res
  })
}

export async function smsSend(biz: string, mobile: string, nvaVal: string) {
  return Axios.post('/portal/pub/sms/send', {
    biz,
    mobile,
    nvc_val: nvaVal,
  })
}
export async function smsLogin(params: QueryParams) {
  return Axios.post('/portal/pub/auth/sms/login', params)
}

export async function pwdLogin(params: QueryParams) {
  return Axios.post('/portal/pub/auth/pwd/login', params)
}

export async function findPwd(params: QueryParams) {
  return Axios.post('/portal/pub/pwd/find', params)
}

export async function pubVerifySms(params: QueryParams) {
  return Axios.post('/portal/pub/sms/verify', params)
}

export async function initInfo(params: QueryParams) {
  return Axios.post('/portal/uc/init', params)
}

export async function sendVerifySms(nvaVal: string) {
  return Axios.post('/portal/uc/sms/send', { nvc_val: nvaVal })
}

export async function verifySms(mobile: string, smsCode: string) {
  return Axios.post('/portal/uc/sms/verify', { mobile, sms_code: smsCode })
}

export async function updateName(name: string) {
  return Axios.post('/portal/uc/update/name', {
    name,
  }).then(() => {
    const profile = store.getters.profile
    if (profile) {
      profile.name = name
      store.commit(UPDATE_ME, profile)
    }
  })
}

export async function updateMobile(form: QueryParams) {
  return Axios.post('/portal/uc/update/mobile', form).then(() => {
    router.replace({
      name: 'Login',
    })
  })
}

export async function updatePwd(params: QueryParams) {
  return Axios.post('/portal/uc/update/passwd', params)
}
